import { DarkTheme } from './dark/darkTheme';
import { DefaultTheme } from './default/defaultTheme';

export const THEMES = [DefaultTheme, DarkTheme];
